import { useEffect, useState } from "react"
import {
  watchLiveDrawings,
  type LiveDrawingInfo,
} from "../services/raffle/liveDrawingService"

export function useLiveDrawing(): LiveDrawingInfo | null {
  const [liveRaffle, setLiveRaffle] = useState<LiveDrawingInfo | null>(null)

  useEffect(() => {
    let unsubscribe: (() => void) | undefined
    let cancelled = false
    const schedule =
      typeof window !== "undefined" && "requestIdleCallback" in window
        ? (window as any).requestIdleCallback
        : (callback: () => void) => window.setTimeout(callback, 1500)
    const cancel =
      typeof window !== "undefined" && "cancelIdleCallback" in window
        ? (window as any).cancelIdleCallback
        : globalThis.clearTimeout

    const id = schedule(() => {
      if (cancelled) {
        return
      }

      unsubscribe = watchLiveDrawings((drawings) => {
        setLiveRaffle(drawings.length > 0 ? drawings[0] : null)
      })
    })

    return () => {
      cancelled = true
      cancel(id)
      unsubscribe?.()
    }
  }, [])

  return liveRaffle
}
